// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"dd4bb13c","107":"ea7d1fe3","482":"f6033e36"}[chunkId] + ".chunk.js";
};